import { get } from "../client";
import { ALL_PARTS, PARTS } from "../routes";

export default {
  get: async (id) => await get(PARTS(id)),

  get_all: async () => await get(ALL_PARTS),
};
